
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down-triangle': {
    width: 9.5,
    height: 6.5,
    viewBox: '0 0 9.5 6.5',
    data: '<path pid="0" d="M0 0h9.5L4.6 6.5 0 0z"/>'
  }
})
